import { useCallback } from "react";
import {
  BaseEdge,
  getStraightPath,
  EdgeLabelRenderer,
  getBezierPath,
  useReactFlow,
  useEdges,
  useNodes,
} from "reactflow";

const CustomEdge = ({
  id,

  sourceX,

  sourceY,

  targetX,

  targetY,

  sourcePosition,

  targetPosition,

  style,

  markerEnd,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,

    sourceY,

    targetX,

    targetY,

    sourcePosition,

    targetPosition,
  });

  const { setEdges } = useReactFlow();

  const edges = useEdges();

  // Filter edges with the same source node and sort by creation order

  const sourceEdges = edges

    .filter((edge) => edge.source === edges.find((e) => e.id === id)?.source)

    .sort(
      (a, b) =>
        edges.findIndex((e) => e.id === a.id) -
        edges.findIndex((e) => e.id === b.id)
    );

  // Find the serial number of the current edge (1-based)

  const edgeSerial = sourceEdges.findIndex((edge) => edge.id === id) + 1;

  const onEdgeDelete = () => {
    setEdges((eds) => eds.filter((edge) => edge.id !== id));
  };

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />

      <EdgeLabelRenderer>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "white",
            border: "1px solid #ff5050",
            borderRadius: "50%",
            fontSize: "12px",
            fontWeight: "bold",
            color: "#ff5050",
            cursor: "pointer",
            pointerEvents: "all",
            zIndex: 1000,
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease",
          }}
          className="edgebutton"
          onClick={(e) => {
            e.stopPropagation();
            onEdgeDelete();
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-10px",
              right: "-10px",
              width: "20px",
              height: "16px",
              background: "#ff5050",
              color: "white",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "10px",
              border: "1px solid white",
              zIndex: 1001,
            }}
          >
            {edgeSerial}
          </div>
          ×
        </div>
      </EdgeLabelRenderer>
    </>
  );
};
export default CustomEdge;
